import axios from "axios";

export const addUPSCQuestion = async (payload) => {
  try {
    const response = await axios.post(
      "https://testseriesapi.econsignsoft.com/api/v1/admin/chat_GPT_Evaluate_UPSC_Question",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    return { code: 500, message: "Server error" };
  }
};
